module.exports = "<app-navigation-sidebar></app-navigation-sidebar>\n\n"